unit View.Facil_Planos_Aliados.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewFacil_Planos_AliadosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbfacil_planos_id: TLabel;
    edfacil_planos_id: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_inicio: TLabel;
    eddata_inicio: TDBEdit;
    lbdata_fim: TLabel;
    eddata_fim: TDBEdit;
    lbplano_ativo: TLabel;
    edplano_ativo: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientFacil_Planos_AliadosGet: TXDataWebClient;
    XDataClientFacil_Planos_AliadosDelete: TXDataWebClient;
    Facil_Planos_AliadosDataset: TXDataWebDataSet;
    Facil_Planos_AliadosDatasetid: TIntegerField;
    Facil_Planos_AliadosDatasetfacil_planos_id: TIntegerField;
    Facil_Planos_AliadosDatasetaliado_id: TIntegerField;
    Facil_Planos_AliadosDatasetdata_inicio: TDateTimeField;
    Facil_Planos_AliadosDatasetdata_fim: TDateTimeField;
    Facil_Planos_AliadosDatasetplano_ativo: TBooleanField;
    Facil_Planos_AliadosDatasetexcluido: TBooleanField;
    Facil_Planos_AliadosDatasetinclusao: TDateTimeField;
    Facil_Planos_AliadosDatasetalteracao: TDateTimeField;
    Facil_Planos_AliadosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientFacil_Planos_AliadosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientFacil_Planos_AliadosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientFacil_Planos_AliadosDeleteError(Error: TXDataClientError);
    procedure Facil_Planos_AliadosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewFacil_Planos_AliadosEdit: TFViewFacil_Planos_AliadosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFacil_Planos_AliadosEdit }

procedure TFViewFacil_Planos_AliadosEdit.btSaveClick(Sender: TObject);
begin
  if Facil_Planos_AliadosDataset.State in dsEditModes then
  begin
        Facil_Planos_AliadosDataset.Post;
    Facil_Planos_AliadosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewFacil_Planos_AliadosEdit.btDeleteClick(Sender: TObject);
begin
  if Facil_Planos_AliadosDataset.State in dsEditModes then
    Facil_Planos_AliadosDataset.Post;
  XDataClientFacil_Planos_AliadosDelete.Delete(Facil_Planos_AliadosDataset.EntitySetName,
    TJSObject(Facil_Planos_AliadosDataset.CurrentData));
end;


class function TFViewFacil_Planos_AliadosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewFacil_Planos_AliadosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewFacil_Planos_AliadosEdit.InsertEntity;
begin
  Facil_Planos_AliadosDataset.Close;
  Facil_Planos_AliadosDataset.SetJsonData('{}');
  Facil_Planos_AliadosDataset.Open;
  Facil_Planos_AliadosDataset.Insert;
end;

class function TFViewFacil_Planos_AliadosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFacil_Planos_AliadosEdit(AForm).FInserting := AInserting;
    TFViewFacil_Planos_AliadosEdit(AForm).FId := AId;
    TFViewFacil_Planos_AliadosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewFacil_Planos_AliadosEdit(AForm).InsertEntity
    else
      TFViewFacil_Planos_AliadosEdit(AForm).LoadEntity;
    TFViewFacil_Planos_AliadosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewFacil_Planos_AliadosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewFacil_Planos_AliadosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Facil_Planos_AliadosDataset.Connection.Model.DefaultSchema.FindEntityType(
      Facil_Planos_AliadosDataset.EntitySetName
    )
  );
  XDataClientFacil_Planos_AliadosGet.Get(Facil_Planos_AliadosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewFacil_Planos_AliadosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewFacil_Planos_AliadosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewFacil_Planos_AliadosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewFacil_Planos_AliadosEdit.XDataClientFacil_Planos_AliadosGetLoad(Response: TXDataClientResponse);
begin
  Facil_Planos_AliadosDataset.Close;
  Facil_Planos_AliadosDataset.SetJsonData(Response.Result);
  Facil_Planos_AliadosDataset.Open;
  
  Facil_Planos_AliadosDataset.Edit;  
end;

procedure TFViewFacil_Planos_AliadosEdit.XDataClientFacil_Planos_AliadosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewFacil_Planos_AliadosEdit.XDataClientFacil_Planos_AliadosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewFacil_Planos_AliadosEdit.Facil_Planos_AliadosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewFacil_Planos_AliadosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewFacil_Planos_AliadosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.facil_planos_aliados.form.message');
  lbMessage := TLabel.Create('view.facil_planos_aliados.form.message.label');
  btCloseMessage := TButton.Create('view.facil_planos_aliados.form.message.button');
  btCancel := TButton.Create('view.facil_planos_aliados.form.btBack');
  btSave := TButton.Create('view.facil_planos_aliados.form.btSave');
  btDelete := TButton.Create('view.facil_planos_aliados.form.btDelete');
  lbid := TLabel.Create('view.facil_planos_aliados.form.lbid');
  edid := TDBEdit.Create('view.facil_planos_aliados.form.edid');
  lbfacil_planos_id := TLabel.Create('view.facil_planos_aliados.form.lbfacil_planos_id');
  edfacil_planos_id := TDBEdit.Create('view.facil_planos_aliados.form.edfacil_planos_id');
  lbaliado_id := TLabel.Create('view.facil_planos_aliados.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.facil_planos_aliados.form.edaliado_id');
  lbdata_inicio := TLabel.Create('view.facil_planos_aliados.form.lbdata_inicio');
  eddata_inicio := TDBEdit.Create('view.facil_planos_aliados.form.eddata_inicio');
  lbdata_fim := TLabel.Create('view.facil_planos_aliados.form.lbdata_fim');
  eddata_fim := TDBEdit.Create('view.facil_planos_aliados.form.eddata_fim');
  lbplano_ativo := TLabel.Create('view.facil_planos_aliados.form.lbplano_ativo');
  edplano_ativo := TDBEdit.Create('view.facil_planos_aliados.form.edplano_ativo');
  lbexcluido := TLabel.Create('view.facil_planos_aliados.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.facil_planos_aliados.form.edexcluido');
  lbinclusao := TLabel.Create('view.facil_planos_aliados.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.facil_planos_aliados.form.edinclusao');
  lbalteracao := TLabel.Create('view.facil_planos_aliados.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.facil_planos_aliados.form.edalteracao');
  lbexclusao := TLabel.Create('view.facil_planos_aliados.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.facil_planos_aliados.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Facil_Planos_AliadosDataset := TXDataWebDataSet.Create(Self);
  Facil_Planos_AliadosDatasetid := TIntegerField.Create(Self);
  Facil_Planos_AliadosDatasetfacil_planos_id := TIntegerField.Create(Self);
  Facil_Planos_AliadosDatasetaliado_id := TIntegerField.Create(Self);
  Facil_Planos_AliadosDatasetdata_inicio := TDateTimeField.Create(Self);
  Facil_Planos_AliadosDatasetdata_fim := TDateTimeField.Create(Self);
  Facil_Planos_AliadosDatasetplano_ativo := TBooleanField.Create(Self);
  Facil_Planos_AliadosDatasetexcluido := TBooleanField.Create(Self);
  Facil_Planos_AliadosDatasetinclusao := TDateTimeField.Create(Self);
  Facil_Planos_AliadosDatasetalteracao := TDateTimeField.Create(Self);
  Facil_Planos_AliadosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientFacil_Planos_AliadosGet := TXDataWebClient.Create(Self);
  XDataClientFacil_Planos_AliadosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbfacil_planos_id.BeforeLoadDFMValues;
  edfacil_planos_id.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_inicio.BeforeLoadDFMValues;
  eddata_inicio.BeforeLoadDFMValues;
  lbdata_fim.BeforeLoadDFMValues;
  eddata_fim.BeforeLoadDFMValues;
  lbplano_ativo.BeforeLoadDFMValues;
  edplano_ativo.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Facil_Planos_AliadosDataset.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetid.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetfacil_planos_id.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetaliado_id.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetdata_inicio.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetdata_fim.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetplano_ativo.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetexcluido.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetinclusao.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetalteracao.BeforeLoadDFMValues;
  Facil_Planos_AliadosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientFacil_Planos_AliadosGet.BeforeLoadDFMValues;
  XDataClientFacil_Planos_AliadosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewFacil_Planos_AliadosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 535;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 475;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 475;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 475;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbfacil_planos_id.SetParentComponent(Self);
    lbfacil_planos_id.Name := 'lbfacil_planos_id';
    lbfacil_planos_id.Left := 24;
    lbfacil_planos_id.Top := 219;
    lbfacil_planos_id.Width := 14;
    lbfacil_planos_id.Height := 13;
    lbfacil_planos_id.Caption := 'facil_planos_id:';
    lbfacil_planos_id.Transparent := True;
    edfacil_planos_id.SetParentComponent(Self);
    edfacil_planos_id.Name := 'edfacil_planos_id';
    edfacil_planos_id.Left := 221;
    edfacil_planos_id.Top := 216;
    edfacil_planos_id.Width := 200;
    edfacil_planos_id.Height := 21;
    edfacil_planos_id.Enabled := True;
    edfacil_planos_id.TabOrder := 7;
    edfacil_planos_id.Text := 'edfacil_planos_id';
    edfacil_planos_id.DataField := 'facil_planos_id';
    edfacil_planos_id.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 246;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 243;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 8;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_inicio.SetParentComponent(Self);
    lbdata_inicio.Name := 'lbdata_inicio';
    lbdata_inicio.Left := 24;
    lbdata_inicio.Top := 273;
    lbdata_inicio.Width := 14;
    lbdata_inicio.Height := 13;
    lbdata_inicio.Caption := 'data_inicio:';
    lbdata_inicio.Transparent := True;
    eddata_inicio.SetParentComponent(Self);
    eddata_inicio.Name := 'eddata_inicio';
    eddata_inicio.Left := 221;
    eddata_inicio.Top := 270;
    eddata_inicio.Width := 200;
    eddata_inicio.Height := 21;
    eddata_inicio.Enabled := True;
    eddata_inicio.TabOrder := 9;
    eddata_inicio.Text := 'eddata_inicio';
    eddata_inicio.DataField := 'data_inicio';
    eddata_inicio.DataSource := DataSource;
    lbdata_fim.SetParentComponent(Self);
    lbdata_fim.Name := 'lbdata_fim';
    lbdata_fim.Left := 24;
    lbdata_fim.Top := 300;
    lbdata_fim.Width := 14;
    lbdata_fim.Height := 13;
    lbdata_fim.Caption := 'data_fim:';
    lbdata_fim.Transparent := True;
    eddata_fim.SetParentComponent(Self);
    eddata_fim.Name := 'eddata_fim';
    eddata_fim.Left := 221;
    eddata_fim.Top := 297;
    eddata_fim.Width := 200;
    eddata_fim.Height := 21;
    eddata_fim.Enabled := True;
    eddata_fim.TabOrder := 10;
    eddata_fim.Text := 'eddata_fim';
    eddata_fim.DataField := 'data_fim';
    eddata_fim.DataSource := DataSource;
    lbplano_ativo.SetParentComponent(Self);
    lbplano_ativo.Name := 'lbplano_ativo';
    lbplano_ativo.Left := 24;
    lbplano_ativo.Top := 327;
    lbplano_ativo.Width := 14;
    lbplano_ativo.Height := 13;
    lbplano_ativo.Caption := 'plano_ativo:';
    lbplano_ativo.Transparent := True;
    edplano_ativo.SetParentComponent(Self);
    edplano_ativo.Name := 'edplano_ativo';
    edplano_ativo.Left := 221;
    edplano_ativo.Top := 324;
    edplano_ativo.Width := 200;
    edplano_ativo.Height := 21;
    edplano_ativo.Enabled := True;
    edplano_ativo.TabOrder := 11;
    edplano_ativo.Text := 'edplano_ativo';
    edplano_ativo.DataField := 'plano_ativo';
    edplano_ativo.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 354;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 351;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 12;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 381;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 378;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 13;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 408;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 405;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 14;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 435;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 432;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 15;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Facil_Planos_AliadosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Facil_Planos_AliadosDataset.SetParentComponent(Self);
    Facil_Planos_AliadosDataset.Name := 'Facil_Planos_AliadosDataset';
    Facil_Planos_AliadosDataset.AfterApplyUpdates := Facil_Planos_AliadosDatasetAfterApplyUpdates;
    Facil_Planos_AliadosDataset.EntitySetName := 'Facil_Planos_Aliados';
    Facil_Planos_AliadosDataset.Connection := DMConnection.ApiConnection;
    Facil_Planos_AliadosDataset.Left := 176;
    Facil_Planos_AliadosDataset.Top := 8;
    Facil_Planos_AliadosDatasetid.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetid.Name := 'Facil_Planos_AliadosDatasetid';
    Facil_Planos_AliadosDatasetid.FieldName := 'id';
    Facil_Planos_AliadosDatasetid.Required := True;
    Facil_Planos_AliadosDatasetfacil_planos_id.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetfacil_planos_id.Name := 'Facil_Planos_AliadosDatasetfacil_planos_id';
    Facil_Planos_AliadosDatasetfacil_planos_id.FieldName := 'facil_planos_id';
    Facil_Planos_AliadosDatasetfacil_planos_id.Required := True;
    Facil_Planos_AliadosDatasetaliado_id.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetaliado_id.Name := 'Facil_Planos_AliadosDatasetaliado_id';
    Facil_Planos_AliadosDatasetaliado_id.FieldName := 'aliado_id';
    Facil_Planos_AliadosDatasetaliado_id.Required := True;
    Facil_Planos_AliadosDatasetdata_inicio.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetdata_inicio.Name := 'Facil_Planos_AliadosDatasetdata_inicio';
    Facil_Planos_AliadosDatasetdata_inicio.FieldName := 'data_inicio';
    Facil_Planos_AliadosDatasetdata_inicio.Required := False;
    Facil_Planos_AliadosDatasetdata_fim.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetdata_fim.Name := 'Facil_Planos_AliadosDatasetdata_fim';
    Facil_Planos_AliadosDatasetdata_fim.FieldName := 'data_fim';
    Facil_Planos_AliadosDatasetdata_fim.Required := False;
    Facil_Planos_AliadosDatasetplano_ativo.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetplano_ativo.Name := 'Facil_Planos_AliadosDatasetplano_ativo';
    Facil_Planos_AliadosDatasetplano_ativo.FieldName := 'plano_ativo';
    Facil_Planos_AliadosDatasetplano_ativo.Required := True;
    Facil_Planos_AliadosDatasetexcluido.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetexcluido.Name := 'Facil_Planos_AliadosDatasetexcluido';
    Facil_Planos_AliadosDatasetexcluido.FieldName := 'excluido';
    Facil_Planos_AliadosDatasetexcluido.Required := False;
    Facil_Planos_AliadosDatasetinclusao.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetinclusao.Name := 'Facil_Planos_AliadosDatasetinclusao';
    Facil_Planos_AliadosDatasetinclusao.FieldName := 'inclusao';
    Facil_Planos_AliadosDatasetinclusao.Required := False;
    Facil_Planos_AliadosDatasetalteracao.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetalteracao.Name := 'Facil_Planos_AliadosDatasetalteracao';
    Facil_Planos_AliadosDatasetalteracao.FieldName := 'alteracao';
    Facil_Planos_AliadosDatasetalteracao.Required := False;
    Facil_Planos_AliadosDatasetexclusao.SetParentComponent(Facil_Planos_AliadosDataset);
    Facil_Planos_AliadosDatasetexclusao.Name := 'Facil_Planos_AliadosDatasetexclusao';
    Facil_Planos_AliadosDatasetexclusao.FieldName := 'exclusao';
    Facil_Planos_AliadosDatasetexclusao.Required := False;
    XDataClientFacil_Planos_AliadosGet.SetParentComponent(Self);
    XDataClientFacil_Planos_AliadosGet.Name := 'XDataClientFacil_Planos_AliadosGet';
    XDataClientFacil_Planos_AliadosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFacil_Planos_AliadosGet, Self, 'OnLoad', 'XDataClientFacil_Planos_AliadosGetLoad');
    XDataClientFacil_Planos_AliadosGet.Left := 64;
    XDataClientFacil_Planos_AliadosGet.Top := 8;
    XDataClientFacil_Planos_AliadosDelete.SetParentComponent(Self);
    XDataClientFacil_Planos_AliadosDelete.Name := 'XDataClientFacil_Planos_AliadosDelete';
    XDataClientFacil_Planos_AliadosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFacil_Planos_AliadosDelete, Self, 'OnLoad', 'XDataClientFacil_Planos_AliadosDeleteLoad');
    SetEvent(XDataClientFacil_Planos_AliadosDelete, Self, 'OnError', 'XDataClientFacil_Planos_AliadosDeleteError');
    XDataClientFacil_Planos_AliadosDelete.Left := 64;
    XDataClientFacil_Planos_AliadosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbfacil_planos_id.AfterLoadDFMValues;
    edfacil_planos_id.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_inicio.AfterLoadDFMValues;
    eddata_inicio.AfterLoadDFMValues;
    lbdata_fim.AfterLoadDFMValues;
    eddata_fim.AfterLoadDFMValues;
    lbplano_ativo.AfterLoadDFMValues;
    edplano_ativo.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Facil_Planos_AliadosDataset.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetid.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetfacil_planos_id.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetaliado_id.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetdata_inicio.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetdata_fim.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetplano_ativo.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetexcluido.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetinclusao.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetalteracao.AfterLoadDFMValues;
    Facil_Planos_AliadosDatasetexclusao.AfterLoadDFMValues;
    XDataClientFacil_Planos_AliadosGet.AfterLoadDFMValues;
    XDataClientFacil_Planos_AliadosDelete.AfterLoadDFMValues;
  end;
end;

end.
